@if (authSessionService.warningVisible()) {
  <section class="session-warning" role="alert" aria-live="assertive">
    <span>Votre session va expirer dans {{ authSessionService.warningSecondsRemaining() }} secondes.</span>
    <button type="button" class="session-warning__button" (click)="authSessionService.continueSession()">
      Continuer la session
    </button>
  </section>
}

@if (authSessionService.reauthenticationVisible()) {
  <section class="session-dialog-backdrop" role="presentation">
    <article class="session-dialog" role="dialog" aria-modal="true" aria-labelledby="session-dialog-title">
      <div class="session-dialog__header">
        <div>
          <p class="session-dialog__kicker">Session securisee</p>
          <h2 id="session-dialog-title">Reconnexion requise</h2>
        </div>
        <span class="session-dialog__status">Contexte conserve</span>
      </div>

      <p class="session-dialog__copy">
        Votre page reste ouverte. Reconnectez-vous pour reprendre exactement l action en cours.
      </p>

      @if (authSessionService.reauthenticationError(); as error) {
        <div class="session-dialog__error" role="alert">{{ error }}</div>
      }

      @if (authSessionService.reauthenticationStep() === 'credentials') {
        <form class="session-dialog__form" (ngSubmit)="submitReauthenticationCredentials()">
          <label>
            <span>Email</span>
            <input
              name="reauthenticationEmail"
              type="email"
              autocomplete="username"
              [(ngModel)]="reauthenticationEmail"
              required
            />
          </label>
          <label>
            <span>Mot de passe</span>
            <input
              name="reauthenticationPassword"
              type="password"
              autocomplete="current-password"
              [(ngModel)]="reauthenticationPassword"
              required
            />
          </label>
          <div class="session-dialog__actions">
            <button type="button" class="session-dialog__button session-dialog__button--ghost" (click)="cancelReauthentication()">
              Quitter
            </button>
            <button type="submit" class="session-dialog__button" [disabled]="authSessionService.reauthenticationSubmitting()">
              {{ authSessionService.reauthenticationSubmitting() ? 'Verification...' : 'Continuer' }}
            </button>
          </div>
        </form>
      } @else {
        <form class="session-dialog__form" (ngSubmit)="submitReauthenticationTwoFactor()">
          <label>
            <span>Code 2FA</span>
            <input
              name="reauthenticationCode"
              type="text"
              inputmode="numeric"
              autocomplete="one-time-code"
              [(ngModel)]="reauthenticationCode"
              required
            />
          </label>
          <div class="session-dialog__actions">
            <button type="button" class="session-dialog__button session-dialog__button--ghost" (click)="cancelReauthentication()">
              Quitter
            </button>
            <button type="submit" class="session-dialog__button" [disabled]="authSessionService.reauthenticationSubmitting()">
              {{ authSessionService.reauthenticationSubmitting() ? 'Verification...' : 'Reprendre' }}
            </button>
          </div>
        </form>
      }
    </article>
  </section>
}

<p-toast position="top-right" />
<router-outlet />
